module.exports = __webpack_public_path__ + "static/media/whatsapp.c83411f3.svg";